<template>
  <a-modal
    ok-text="确认建档"
    cancel-text="取消"
    :width="430"
    title="编辑信息"
    v-model:visible="unverified.visible"
    @ok="save"
    @cancel="cancel"
    :okText="unverified.btnText"
  >
    <a-form :labelCol="{ style: { width: '55px' } }" class="unverified">
      <a-form-item v-bind="validateInfos.name" label="姓名">
        <a-auto-complete
          class="item_component"
          v-model:value="unverified.form.name"
          @search="handleSearch"
        >
          <template #default>
            <a-input
              @keydown="unverified.btnText = '确定建档'"
              :maxlength="50"
              placeholder="输入姓名、手机号搜索"
              :value="unverified.form.name"
            ></a-input>
          </template>
          <template #options>
            <a-select-option
              v-for="patient in patients"
              :key="`${patient.patientId}`"
              @click="checkPatient(patient)"
              class="auto-complete_item"
            >
              <div class="content">
                <span class="item">
                  <div v-html="patient._name"></div>
                </span>
                <span class="item">
                  {{ patient.gender ? '男' : '女' }}
                </span>
                <span class="item">{{ patient.age }}岁</span>
              </div>
              <div class="tips">绑定医生：{{ patient.lastBindDrName }}</div>
            </a-select-option>
          </template>
        </a-auto-complete>
      </a-form-item>
      <a-form-item v-bind="validateInfos.gender" label="性别">
        <a-select
          placeholder="请选择"
          class="item_component"
          ref="select"
          v-model:value="unverified.form.gender"
        >
          <a-select-option @click="unverified.btnText = '确定建档'" value="1">男</a-select-option>
          <a-select-option @click="unverified.btnText = '确定建档'" value="0">女</a-select-option>
          <a-select-option @click="unverified.btnText = '确定建档'" value="">未知</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="年龄">
        <a-input-number
          @keydown="unverified.btnText = '确定建档'"
          v-model:value="unverified.form.age"
          placeholder="请输入"
          class="item_component"
          :min="0"
        ></a-input-number>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script setup>
import { reactive, defineExpose, computed, nextTick } from 'vue'
import { Form, message } from 'ant-design-vue'
import {
  getPatientName,
  //savePrePatient,
  updatePrePatient
} from '@/api/patientFile'
import { useStore } from 'vuex'
import { ref } from 'vue'
import { debounce } from '@/utils/index'
import { getUserInfoByType } from '@/api/UserPool'
const store = useStore()
const info = computed(() => store.state.patientFile.info)
const patientType = computed(() => store.state.patientFile.patientType)

const useForm = Form.useForm
const rulesRef = reactive({
  name: [
    {
      required: true,
      message: '请输入',
      trigger: 'blur'
    }
  ],
  gender: [
    {
      required: true,
      message: '请选择性别',
      trigger: 'blur'
    },
    {
      trigger: 'change',
      validator(_, value) {
        if (value !== undefined && value !== null && value !== '') {
          return Promise.resolve()
        } else {
          return Promise.reject()
        }
      }
    }
  ]
})
const unverified = reactive({
  visible: false,
  // 匹配关联
  btnText: '确定建档',
  form: {
    name: '',
    // 性别 0女 1男
    gender: null,
    age: null,
    phone: null
  }
})

const patients = ref([])
const { validate, validateInfos, clearValidate } = useForm(unverified.form, rulesRef)
// 新增 （废弃）
// const saveNewPatient = () => {
//   validate().then(_ => {
//     const { RealPhone } = info.value
//     const params = {
//       ...unverified.form,
//       phone: unverified.form.phone || RealPhone
//     }
//     savePrePatient(params).then(result => {
//       message.success('操作成功')
//       cancel()
//       const params = {
//         patientId: result.id,
//         patientType: 0
//       }
//       store.dispatch('patientFile/getInfo', params)
//     })
//   })
// }
// 保存预建档的
const saveCurPatient = () => {
  validate().then(_ => {
    const { prePatientId } = info.value
    const params = {
      patientId: prePatientId,
      ...unverified.form
    }
    // 调接口
    updatePrePatient(params).then(result => {
      message.success('操作成功')
      cancel()
      const params = {
        patientId: result.prePatientId,
        patientType: 0
      }
      store.dispatch('patientFile/getInfo', params)
    })
  })
}
const save = () => {
  saveCurPatient()
}
// 关闭弹窗
const cancel = () => {
  unverified.visible = false
  unverified.form.name = ''
  unverified.form.gender = null
  unverified.form.age = null
  patients.value = []
  unverified.btnText = '确定建档'
  nextTick(() => {
    clearValidate()
  })
}
// 防抖
const handleSearch = debounce(val => {
  patients.value = []
  if (!val) return
  const params = { name: val }
  getPatientName(params)
    .then(result => {
      const arr = result.map(item => {
        const { name } = item || {}
        // 将结果中的机构名称中的搜索关键词进行高亮处理
        const regExp = new RegExp(val, 'g')
        item._name = name.replace(regExp, `<span style="color: #1890FF">${val}</span>`)
        return item
      })
      nextTick(() => {
        patients.value = arr
      })
    })
    .catch(err => {})
}, 500)

// 编辑预建档患者信息
const openEdit = () => {
  if (patientType.value) {
    message.warning('仅支持编辑预建档患者信息')
    return
  }
  // 获取患者绑定手机号
  const params2 = {
    accountType: -1,
    id: info.value.prePatientId
  }
  getUserInfoByType(params2).then(res => {
    unverified.visible = true
    unverified.form.patientId = info.value.prePatientId
    unverified.form.name = info.value.name
    // null 转成 ''
    unverified.form.gender = typeof info.value.gender === 'number' ? info.value.gender + '' : ''
    unverified.form.age = info.value.age
    unverified.form.phone = res.phone
    nextTick(() => {
      clearValidate()
    })
  })
}
function checkPatient(patient) {
  const { name, gender, age, phone } = patient
  unverified.form.gender = gender + ''
  unverified.form.age = age
  unverified.form.phone = phone
  unverified.btnText = '匹配关联'
  nextTick(() => {
    unverified.form.name = name
    patients.value = []
  })
}

defineExpose({
  openEdit
})
</script>

<style lang="scss" scoped>
.unverified {
  .item_component {
    width: 100%;
  }
}
.auto-complete_item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 70px;
  padding: 10px 16px;
  .content {
    margin-bottom: 8px;
    .item {
      display: inline-block;
      margin-right: 12px;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
    }
  }
  .tips {
    font-size: 14px;
    color: #999999;
  }
}
</style>
